// Library Class
import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, HostListener, SimpleChanges, ViewEncapsulation, OnChanges, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatSelectionList } from '@angular/material/list';
import { NgbCalendar, NgbDate, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatCalendar, MatDatepicker } from '@angular/material/datepicker';

// Service Class
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { BroadcastService } from '../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../services/infrastructure/config.service';
import { CppReturnsService } from '../../../services/cpp-returns/cpp-returns.service';
import { ContainerReturnService } from '../../../services/container-return/container-return.service';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { ContainerReturnsAddProductSliderModelService } from '../container-returns-add-product/container-returns-add-product-slider-model.service';
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog.component';
import { FilterOption } from '../../../common/components/filter/filter-model';
import { ControlType } from '../../../common/components/filter/filter-enum';

// Modal Class
import { DashboardFilter } from '../../../models/DashboardFilter';
import { MasterConstants } from '../../../common/constants/master-constants';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';
import { CommonService } from '../../../services/common/common.service';
import { UserSecurityService } from '../../../services/common/user-security.service';

@Component({
  selector: 'app-container-returns-add-edit',
  templateUrl: './container-returns-add-edit.component.html',
  styleUrls: ['./container-returns-add-edit.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: 0, display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class ContainerReturnsAddEditComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('freightInstructionCtrl') freightInstructionCtrl: MatSelectionList;
  @ViewChild('productTable', { read: MatSort }) productSort: MatSort;
  @ViewChild('calendar') matcalendar: MatCalendar<Date>;
  @ViewChild('picker') datepicker: MatDatepicker<any>;
  @ViewChild('datepickerFooter') datepickerFooter: ElementRef;

  filterOptionsData: Array<FilterOption>;
  filter: any;
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  nextErrorId = 0;
  nextLotNumber: string;
  // Header selected values
  shipToAccount: number;
  public deliveryAccount: number;
  shipToAccountName: number;
  shipToAccountItems: any[];
  soldToFacility: any[];
  soldToAccount: number;
  headerCompany = MasterConstants.US_COMPANYCODE;
  cropYear: any;
  dashboardFilter: DashboardFilter;
  originalProductItemsDataSource: any;
  searchValue = '';
  partialSearchValue = '';
  lotNumberList: any = [];
  invoicedProductList: any = [];
  productAllDataSource: any;
  displayedColumns: string[] = ['checkbox', 'product', 'returnType', 'itemNumber', 'serialNumber', 'dumpedUnits', 'uom', 'packageSize', 'notes'];
  allTicketChecked = false;
  isSaveOrderDraftEnable = false;
  isPlaceOrderEnable = false;
  isAddProductEnable = false;
  showTabs = false;
  showScaleTabs = false;
  tabNode: string;
  editToolKit = false;
  isParent = false;
  lineStatus: any = '';
  requestOnBehalfList: any = [];
  requestedByUser: string;
  currentRequestedUser: string;
  statusList: any = [
    { id: 'ERROR', value: 'ERROR' },
  ];
  returnTypeSelected: any;
  // Search Type set Up fro grid
  searchTypeList: any = [

    { name: 'Item Number', value: 'itemNumber' },
    { name: 'Product Name', value: 'productName' },
    { name: 'Lot/Serial Number', value: 'serialNumber' },
  ];
  shipToDataLoading = true;
  disablecheckbox: any;
  disableScaleCheckbox: any;
  selectedCount = 0;
  checkBoxCount = 0;
  selectedTicketCount = 0;
  selectedAccountName: any = '';
  isSearchClicked: any;
  index: any;
  enable: any;
  returnRequestNumber = 0;
  containerReturnRequestId = 0;
  isEditMode = false;
  dataChangeSubscription: any;
  hasChangeAdded = false;
  dateFilter: any;
  sub: Subscription;
  filteredDataCount = 0;
  qtyCount = 0;
  totalPrice = 0;
  isNotValid = false;
  accountEmail: string;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  readOnlyAccess = false;
  userMenuAccessList: any;
  date = new Date();
  minDate = new Date();
  maxDate = new Date(this.date.setMonth(this.date.getMonth() + 6));
  dsmInfo: string;
  dsmId = 0;
  filterValueList: any = [];
  productFilters: any;
  productList: any[];
  productSearchFilter: string;
  filterInvoicedProductitems: any[] = [];
  isAllProductChecked = false;
  userIdRole: string;
  createRequestAccess = false;
  editApprovalList: any = {};
  roleType: string;
  enableCreate = true;
  requestStatus: string;
  isValidLineStatus = false;
  isExpanded = true;
  isPickupDateValid = true;
  isNameValid: boolean;
  isContactValid: boolean;
  isPalletValid: boolean;
  deliverToAnotherLocation = false;
  showSubmitToJde = false;
  showSubmitReturn = false;
  breadcrumbtext: string;
  packageSizeMasterList: any = [];
  onBehalfUser: any;
  selectedUserName: string;
  validateEvolveData: any;
  disableRejectedLine = true;
  isIncreaseQtyEnable = true;
  isDecreaseQtyEnable = true;
  productLineSub: Subscription;
  selectedWeekdays = [];
  defaultDelDate = new Date();
  desiredDelDate = new Date();
  selectedShipToWeekdays = [];
  defaultShipToDelDate = new Date();
  desiredShipToPickupDate = new Date();
  isAcctSDM = false;
  returnTypeArray: Array<any> = [];
  isShowOrginal = true;
  isDisableQtyReturnType = false;
  isShowNonSubEmail = true;
  chatAccess = true;
  public freightInstruction: any = [];
  // set default pickup date as T+2 for new return.
  public desiredPickupDate: any;
  public contactName: string;
  public contactNumber: string;
  public customerPONumber: string;
  public shippingInstructions: string;
  public selectedFreightInstructionOptions: any;
  public palletCount: string;
  public deliveryAccountList: Array<any> = [];
  private subscription = new Subscription();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private toastrService: ToastrService,
    public cppReturnsService: CppReturnsService,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    public matDialog: MatDialog,
    private containerReturnsAddProductSliderModelService: ContainerReturnsAddProductSliderModelService,
    private containerReturnsService: ContainerReturnService,
    private localStorageService: LocalStorageService,
    private userSecurityService: UserSecurityService,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();

    this.subscription.add(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));
  }

  ngOnInit() {
    this.requestStatus = this.containerReturnsService.returnRequestStatus;
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.cropYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isShowNonSubEmail = false;
        } else {
          this.isShowNonSubEmail = true;
        }
        this.userIdRole = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userIdRole;
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.createRequestAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS);

          this.roleType = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).roleType.toUpperCase();
          // Get Return Request Id from URL
          this.subscription.add(this.activatedRoute.params.subscribe(x => {
            this.errorMsgs = [];
            if (x['containerReturnRequestId']) {
              this.containerReturnRequestId = +x['containerReturnRequestId'];
              this.isEditMode = true;
              this.isExpanded = false;
              this.editButtonStatus();
              this.getOrderDetails();
            }
            else {
              this.enableCreate = true;
            }
          }));
        }
        this.enableCreate = true;
      }
    }
    this.hasChangeAdded = false;
    this.loadMasterData();
    this.productAllDataSource = new MatTableDataSource([]);
    this.disablecheckbox = true;
    this.disableScaleCheckbox = true;
    this.getAccountList();
    this.getReturnTypeList();
    this.getFreightList();
    this.containerReturnsService.setEditModeStatus(false);
    this.enableFiltersAndButtonAsPermission();

    this.subscription.add(this.containerReturnsAddProductSliderModelService.addModelData.subscribe(selectedProductList => {
      if (selectedProductList.length > 0) {
        this.addNewProducts(selectedProductList);
      }
    }));
    this.subscription.add(this.userSecurityService.getChatAccess().subscribe(results => {
      this.chatAccess = results.isChatActive;
    }));

    this.validateDateFilter();
    this.errorMsgs = new Array();

    this.productSearchFilter = this.searchTypeList[0].value;
    this.setFilterAndGridColumn();
    this.setDropDownValues();
  }

  // add product from the add product tab.
  addNewProducts(productList: any[]) {
    if (productList.length > 0) {
      this.disablecheckbox = false;
      this.disableScaleCheckbox = false;
      this.editToolKit = false;
      this.showTabs = false;
      this.showErrorBlock = false;
      this.errorMsgs = [];
      this.isEditMode = this.containerReturnsService.getEditModeStatus();
      this.originalProductItemsDataSource = this.productAllDataSource.data;
      const orderList = [];
      let rowId = 1;
      this.productAllDataSource.data.forEach(x => {
        orderList.push(x);
        if (x.rowId > rowId) { rowId = x.rowId; }
      });
      let productAdded = false;
      productList.forEach(item => {
        if (!productAdded) {
          productAdded = true;
        }
        const duplicateData = orderList.find(y => y.itemId == item.itemId && y.lotNumber == item.lotNumber);
        // orderList = orderList.filter(y => y.itemNumber != item.itemNumber && y.lotNumber != item.lotNumber);
        item.lineErrors = { 'itemId': item.itemId, 'errors': [] };
        item.lineError = false;
        item.isShowOrginal = true;
        item.returnQuantity = item.orderQtyNetChange;
        if (duplicateData == undefined || duplicateData == null || duplicateData.length == 0) {
          orderList.push(item);
        }
      });
      if (productAdded) {
        this.toastrService.info('Product Added');
        productAdded = false;
      }
      orderList.map((x, index) => {
        x['rowId'] = index + 1;
        x['tempReturnQty'] = x.returnQuantity;
        return x;
      });
      this.productAllDataSource.data = orderList;
      this.originalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));
      this.enablePlaceOrderAndSaveOrderDraft();

      this.selectedCount = orderList.length;
      this.isAllProductChecked = false;
      this.bindDataSource(orderList, true);
    }
  }

  // Observe Input element change
  ngOnChanges(changes: SimpleChanges) {
    this.productSearchFilter = this.searchTypeList[0].value;
  }

  // Set Filter and Grid Columns
  setFilterAndGridColumn() {
    this.filterOptionsData = [
      { label: 'Product Name', key: 'productName', controlType: ControlType.Text },
      { label: 'Lot/Serial Number', key: 'serialNumber', controlType: ControlType.Text },
      { label: 'Item Number', key: 'itemNumber', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'value' },
    ];
  }

  // Set Drop down values for filter
  setDropDownValues() {
    // Item Number master data
    if (this.localStorageService.get(MasterConstants.CONTAINER_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.filterOptionsData.find(x => x.key === 'itemNumber').controlData = JSON.parse(this.localStorageService.get(MasterConstants.CONTAINER_RETURN_ITEM_NUMBER_MASTER_LIST));
    } else {
      this.subscription.add(this.containerReturnsService.getItemNumberList().subscribe((result: any[]) => {
        this.localStorageService.set(MasterConstants.CONTAINER_RETURN_ITEM_NUMBER_MASTER_LIST, JSON.stringify(result));
        this.filterOptionsData.find(x => x.key === 'itemNumber').controlData = JSON.parse(this.localStorageService.get(MasterConstants.CONTAINER_RETURN_ITEM_NUMBER_MASTER_LIST));
      }));
    }
  }

  // fires and event return type change in product detail.
  onReturnTypeSelect(event, id) {
    const returnType = event.target.value;
    this.retrunTypeCase(returnType, id);
  }

  // function for the  return type change.
  retrunTypeCase(returnType, id) {
    switch (returnType) {
      case 'EMT':
        this.isDisableQtyReturnType = true;
        this.productAllDataSource.data.map((x) => {
          if (x['rowId'] == id) {
            x['returnQuantity'] = 1;
            x['tempunitOfMeasureSecondary'] = 'EA';
            x['isDisableQtyReturnType'] = true;
            x['isShowOrginal'] = false;
            x = this.validateReturnType(x);
            x = this.validateQty(x);
          }
        });
        break;
      case 'PRT':
        this.productAllDataSource.data.map((x) => {
          if (x['rowId'] == id) {
            x['isDisableQtyReturnType'] = false;
            x['tempunitOfMeasureSecondary'] = '';
            x['isShowOrginal'] = true;
            x['returnQuantity'] = x.tempReturnQty;
            x = this.validateReturnType(x);
          }
        });
        // Uom and qty to be fetch from outstanding container bussiness site
        break;
      case 'FLD':
        this.productAllDataSource.data.map((x) => {
          if (x['rowId'] == id) {
            x['isDisableQtyReturnType'] = true;
            x['tempunitOfMeasureSecondary'] = '';
            x['isShowOrginal'] = true;
            x['returnQuantity'] = x.orderQtyNetChange;
            x = this.validateReturnType(x);
          }
        });
      // Uom and qty to be fetch from outstanding container bussiness site
    }
  }

  // Filter Search
  filterSearchClick(event) {
    this.filter = event;
    this.productFilters = event;
    this.applyFilterData(this.productFilters);
  }

  // checks the select checkbox in product details.
  setSelectAllChkStatus() {
    if (this.productAllDataSource.filteredData.length > 0) {
      this.checkBoxCount = this.productAllDataSource.filteredData.filter(x => x.isSelected === true).length;
      const eligibleSelectableRows = this.productAllDataSource.filteredData.filter(x => x.detailLineStatus !== 'X');
      this.isAllProductChecked = this.checkBoxCount === eligibleSelectableRows.length;
    } else {
      this.checkBoxCount = 0;
      this.isAllProductChecked = false;
    }
  }

  // Filter clear button click method
  filterClearAllClick(event) {
    this.filter = event;
    this.applyFilterData(event);
    this.productFilters = event;
  }

  // Filter grid data on type
  applyFilterData(filterValue: any) {
    this.productAllDataSource.filter = filterValue;
    this.setSelectAllChkStatus();
  }

  // validate date filter.
  validateDateFilter() {
    this.dateFilter = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      const calendarDate = d;
      // Prevent Saturday and Sunday from being selected.
      return calendarDate >= currentDate;
    };
  }

  // Toggle Pickup Section
  togglePickup() {
    this.isExpanded = !this.isExpanded;
  }

  // Bind grid data source and filter predicate sounce
  bindDataSource(orderList: any, isClone: boolean, isSortApply: boolean = true) {
    if (orderList && orderList != null) {
      this.productAllDataSource = new MatTableDataSource(orderList);
      this.productAllDataSource.sort = this.productSort;
      this.productAllDataSource.filterPredicate = (data: any, filter: any) => {
        if (
          (filter.productName == null || (filter.productName.trim().toLowerCase().split(',').filter(x => data.itemDescription.trim().toLowerCase().indexOf(x.trim()) > -1).length > 0))
          && (filter.itemNumber == null || filter.itemNumber.length == 0 || (filter.itemNumber.indexOf(data.itemNumber) > -1))
          && (filter.serialNumber == null || (filter.serialNumber.trim().toLowerCase().split(',').filter(x => data.lotNumber.trim().toLowerCase().indexOf(x.trim()) > -1).length > 0))
        ) {
          return true;
        }
        else {
          return false;
        }
      };
      // this.applyFilterData(this.productFilters);
    }
  }

  public clearAllFilter() {
    this.filterValueList = new Array();
    this.searchValue = '';
    this.productList = new Array();
    this.applyFilterData(this.productFilters);
    this.isAllProductChecked = false;
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  // Design
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // Design : Set height
  setHeight() {
    const createTemplateHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.create-return-outer').css('max-height', createTemplateHeight + 'px');
  }

  // Edit/Approval screen enable/disbale buttons
  editButtonStatus() {
    this.disablecheckbox = false;
    this.disableScaleCheckbox = false;
    this.containerReturnsService.setEditModeStatus(true);
    this.isAddProductEnable = true;
    this.enableCreate = false;
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    const tempDate = new Date();
    const date = tempDate.toISOString();
    this.subscription.add(this.containerReturnsService.getEditRequestDetail(this.containerReturnRequestId).subscribe((result: any) => {
      this.containerReturnsService.setEditModeStatus(true);
      const arrproducts = [];
      this.isEditMode = true;
      this.isPickupDateValid = true;
      this.isNameValid = true;
      this.isContactValid = true;
      this.containerReturnsService.returnRequestStatus = result.returnRequestStatus;
      this.accountEmail = result.email;
      this.requestStatus = result.returnRequestStatus;
      if (result.returnRequestStatus === 'DRAFT') {
        this.isSaveOrderDraftEnable = true;
      } else {
        this.isSaveOrderDraftEnable = false;
      }
      if (result.pickupInfo['requestDate'] == null) {
        result.pickupInfo['requestDate'] = '';
      }
      if (result.pickupInfo['requestDate'] != '' && result.returnRequestStatus === 'DRAFT') {
        if (result.pickupInfo['requestDate'] < date) {
          result.pickupInfo['requestDate'] = date;
        }
      }
      this.enableCreate = false;
      this.editApprovalList = result;
      this.disablecheckbox = false;
      this.disableScaleCheckbox = false;
      if (result.containerReturnsProductList && result.containerReturnsProductList.length > 0) {
        result.containerReturnsProductList.forEach((x, index) => {
          const tempObj = {};
          tempObj['isSelected'] = false;
          tempObj['rowId'] = index + 1;
          tempObj['containerReturnRequestDetailId'] = x.containerReturnRequestDetailId;
          tempObj['eligibleUnit'] = x.isManualLine ? 0 : x.eligibleUnit;
          tempObj['lineErrors'] = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
          tempObj['itemDescription'] = x.itemDescription;
          tempObj['returnType'] = x.containerFillStatus;
          tempObj['itemId'] = x.itemId;
          tempObj['containerItemNumber'] = x.containerItemNumber;
          tempObj['unitOfMeasureSecondary'] = x.um;
          tempObj['um'] = x.um;
          tempObj['tempReturnQty'] = x.returnQuantity;
          tempObj['packageSize'] = x.packageSize;
          tempObj['lotNumber'] = x.lotSerialNumber;
          tempObj['customerNotes'] = x.customerNotes;
          tempObj['unitPrice'] = x.unitPrice;
          tempObj['itemVendorName'] = x.itemVendorName;
          tempObj['orderQtyNetChange'] = x.orderQtyNetChange;
          tempObj['itemNumber'] = x.itemNumber;

          tempObj['returnQuantity'] = x.returnQuantity == null ? 0 : x.returnQuantity;
          if (x.containerFillStatus == 'EMT') {
            tempObj['returnQuantity'] = 1;
            tempObj['tempunitOfMeasureSecondary'] = 'EA';
            tempObj['isDisableQtyReturnType'] = true;
            tempObj['isShowOrginal'] = false;
            tempObj['tempReturnQty'] = 1;
          }

          if (x.containerFillStatus == 'PRT') {
            tempObj['isDisableQtyReturnType'] = false;
            tempObj['isShowOrginal'] = true;
            tempObj['tempReturnQty'] = x.returnQuantity;
          }

          if (x.containerFillStatus == 'FLD') {
            tempObj['isDisableQtyReturnType'] = true;
            tempObj['isShowOrginal'] = true;
            tempObj['tempReturnQty'] = x.returnQuantity;
          }

          arrproducts.push(tempObj);
        });
      }
      this.returnRequestNumber = result.returnRequestNumber;
      this.shipToAccount = result.shipToAccountId;
      if (this.shipToAccountItems) {
        const accountItem = this.shipToAccountItems.filter(x => x.accountNumber === this.shipToAccount);
        if (accountItem && accountItem.length > 0) {
          this.selectedAccountName = accountItem[0].accountName;
          this.shipToAccountName = accountItem[0].accountName;
          this.soldToFacility = [accountItem[0].soldToAccount];
          this.soldToAccount = accountItem[0].soldToAccount.accountNumber;
          this.fetchDeliverToFacilityList(accountItem[0].accountNumber, accountItem[0].parentNumber);
        }
        else if (result.shipToAccount) {
          this.selectedAccountName = result.shipToAccount.accountName;
          this.shipToAccountName = result.shipToAccount.accountName;
          this.soldToFacility = [result.soldToAccount];
          this.soldToAccount = result.soldToAccount.accountNumber;
          this.fetchDeliverToFacilityList(result.shipToAccount.accountNumber, result.shipToAccount.parentNumber);
        }
      }

      this.containerReturnsService.setSelectedAccountNo(this.shipToAccount);
      this.isParent = result.isParent;
      this.getFilterMasterList();
      this.containerReturnsService.setProductList(arrproducts);
      this.originalProductItemsDataSource = [];
      this.bindDataSource(arrproducts, true);
      this.originalProductItemsDataSource = JSON.parse(JSON.stringify(arrproducts));
      this.selectedCount = result.containerReturnsProductList.length;
      this.checkBoxCount = 0;
      this.requestedByUser = result.requestedBy;
      this.onBehalfUser = result.requestedBy;

      if (this.isEditMode && this.requestStatus != 'DRAFT') {
        this.readOnlyAccess = true;
        this.displayedColumns = ['checkbox', 'product', 'lotNumber', 'uom', 'units', 'dumpedUnits', 'notes'];
      }

      this.enableFiltersAndButtonAsPermission();
      this.enablePlaceOrderAndSaveOrderDraft();
      this.containerReturnsService.setSelectedAccountNo(result.shipToAccountId);

      this.contactName = result.pickupInfo.contactName;
      this.contactNumber = result.pickupInfo.contactNumber;
      this.customerPONumber = result.pickupInfo.custPONumber;
      this.selectedFreightInstructionOptions = this.freightInstruction.filter(x => result.pickupInfo.freightInstructions.indexOf(x.id) > -1);
      this.deliveryAccount = result.pickupInfo.pickUpLocation;
      this.deliverToAnotherLocation = this.deliveryAccount ? true : false;
      this.shippingInstructions = result.pickupInfo.shippingInstructions;
      if (result.pickupInfo.requestDate) {
        this.desiredPickupDate = new Date(result.pickupInfo.requestDate);
      }

      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // enable filtes and button based on edit mode
  enableFiltersAndButtonAsPermission() {
    if (!this.isEditMode) {
      this.showSubmitReturn = true;
      this.showSubmitToJde = false;
      this.breadcrumbtext = 'Create Return Request';
    }
    else if (this.isEditMode && this.requestStatus == 'DRAFT' && this.createRequestAccess) {
      this.showSubmitReturn = true;
      this.showSubmitToJde = false;
      this.breadcrumbtext = 'Edit Return Request [' + this.returnRequestNumber + ']';
    }
  }

  // Enable/Disable Save Draft Button and Place Order Button
  enablePlaceOrderAndSaveOrderDraft() {
    if (this.productAllDataSource && this.productAllDataSource.data.length > 0 && this.shipToAccount && (!this.isNotValid) /* && this.checkAnyValidLineItem()*/) {
      this.isSaveOrderDraftEnable = true;
    } else {
      this.isSaveOrderDraftEnable = false;
    }
  }

  // toggle for product detail page.
  showProductDetails(item) {
    item.isProductDetailDisplayed = !item.isProductDetailDisplayed;
  }

  // Load master data
  loadMasterData() {
    // get Item Number List
    if (this.localStorageService.get(MasterConstants.CPP_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.invoicedProductList = JSON.parse(this.localStorageService.get(MasterConstants.CPP_RETURN_ITEM_NUMBER_MASTER_LIST));
    }
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // for adding product.
  addProduct() {
    this.containerReturnsAddProductSliderModelService.activeSlider('AddContainerReturnsAddProductSlider');
  }

  // for checkbox enable.
  enableAllCheckBoxes(isChecked) {
    this.isAllProductChecked = isChecked;
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.editToolKit = true;
      this.productAllDataSource.data.forEach(x => {
        x.isSelected = true;
      });
      this.checkBoxCount = this.productAllDataSource.filteredData.filter(x => x.isSelected == true).length;
      const selectedItem = this.productAllDataSource.filteredData.filter(x => x.isSelected == true);
      if (selectedItem && selectedItem.length > 0) {
        this.editToolKit = true;
        if (this.containerReturnsService.getEditModeStatus()) {
          this.showTabs = true;
          this.isSearchClicked = false;
        }

        this.isValidLineStatus = selectedItem.filter(item => item.lineStatus == '' || item.lineStatus == null || item.lineStatus == 'DRAFT' || item.returnRequestItemId == 0).length > 0 ? true : false;
      }
      else {
        this.editToolKit = false;
      }
    }
    else {
      this.showTabs = false;
      this.editToolKit = false;
      this.productAllDataSource.data.forEach(x => {
        x.isSelected = false;
      });
      this.checkBoxCount = 0;
    }
  }

  // get product detail item number master data.
  getFilterMasterList() {
    if (this.localStorageService.get(MasterConstants.CPP_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.invoicedProductList = JSON.parse(this.localStorageService.get(MasterConstants.CPP_RETURN_ITEM_NUMBER_MASTER_LIST));
    }
  }

  // for email change.
  hasEmailAddressChanged() {
    if (this.isEditMode) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { seedReturnEmailAddressValue: true });
    }
  }

  // for setting the user email.
  setUserEmail(event) {
    if (event) {
      this.accountEmail = this.isShowNonSubEmail ? this.accountEmail : event.userEmail;
      this.selectedUserName = event.userName;
      this.requestedByUser = event.userId;
    } else {
      this.accountEmail = null;
      this.requestedByUser = null;
      this.selectedUserName = null;
    }
    if (this.isEditMode) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { hasReturnRequestOnBehalfOfChange: true });
    }
  }

  // for getting shipto value.
  getShipTo(event) {
    if (event) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.add(this.containerReturnsService.getDraftReturnRequest(event.accountNumber)
        .subscribe(response => {
          if (response > 0) {
            this.containerReturnRequestId = response;
            // display confirm message if existing Draft return request for the selected account and product line
            const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
              disableClose: true,
              width: '480px',
              panelClass: 'drafSeedReturnConfirmModal',
              data: {
                title: 'Confirmation',
                htmlMessage: 'There is an existing Draft return request for the selected account and product line. Do you want to continue with that?',
                labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm'
              }
            });
            this.subscription.add(dialogRef.afterClosed().subscribe(result => {
              // If user selected ok
              if (result == true) {
                this.router.navigate(['/container-returns/request-products', this.containerReturnRequestId]);
              } else {
                this.setValuesForCreateNewReturn(event);
              }
            }));
          } else {
            this.soldToFacility = [event.soldToAccount];
            this.soldToAccount = event.soldToAccount.accountNumber;
            this.setValuesForCreateNewReturn(event);
          }
          this.loaderService.setLoaderStatus(false);
        }, error => this.loaderService.setLoaderStatus(false))
      );
    } else {
      this.dsmInfo = '';
      this.dsmId = 0;
      this.soldToFacility = null;
      this.soldToAccount = null;
      this.deliveryAccount = null;
      this.deliveryAccountList = null;
      this.isAddProductEnable = false;   // Disable Add Product Button
      this.invoicedProductList = [];
      if (this.currentRequestedUser) {
        const requestItem = this.requestOnBehalfList.filter(r => r.userId == this.currentRequestedUser);
        this.onBehalfUser = requestItem[0].userId;
        this.accountEmail = this.isShowNonSubEmail ? this.accountEmail : requestItem[0].userEmail;
        this.requestedByUser = requestItem[0].userId;
      }
    }

    this.clearAllFilter();
    // reset pickup location checkbox & dropdown if ship to is changed or reset.
    this.deliverToAnotherLocation = false;
    this.deliveryAccount = null;
    this.productSearchFilter = this.searchTypeList[0].value;
    this.disablecheckbox = true;
    this.errorMsgs = new Array();
    this.showErrorBlock = false;
    this.editToolKit = false;
    this.showTabs = false;
    this.originalProductItemsDataSource = [];
    this.bindDataSource([], true);
    this.checkBoxCount = 0;
    this.selectedCount = 0;
    this.isSearchClicked = true;
    this.editToolKit = false;
    this.enableAllCheckBoxes(false);
    this.showScaleTabs = false;
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  // setting the value on new creation
  public setValuesForCreateNewReturn(event) {
    this.loaderService.setLoaderStatus(true);
    this.isExpanded = false;
    this.isAddProductEnable = true;
    this.soldToFacility = [event.soldToAccount];
    this.soldToAccount = event.soldToAccount.accountNumber;

    this.selectedAccountName = event.accountName;
    this.shipToAccount = event.accountNumber;
    this.containerReturnsService.setSelectedAccountNo(event.accountNumber);
    this.containerReturnsService.setSelectedParentAccountNo(event.parentNumber);
    this.getFilterMasterList();

    this.fetchDeliverToFacilityList(event.accountNumber, event.parentNumber);
    this.loaderService.setLoaderStatus(false);
  }

  // function for save draft with a bool value.
  saveDraft(isSubmit: boolean) {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');
    if (this.validateOrder(isSubmit)) {
      this.isPlaceOrderEnable = false;
      this.isSaveOrderDraftEnable = false;
      const productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));
      const newLineItems = [];
      let isReturnTypeLessThanQuantity = false;
      productList.filter(x => {
        newLineItems.push(JSON.parse(JSON.stringify(x)));
        x.lineStatus = 'DRAFT';
        x.errorMessage = null;
      });
      productList.map((x) => {
        // x['containerItemDescription'] = x.itemDescription
        x['containerFillStatus'] = x.returnType;
        // x['containerItemNumber'] = x.itemNumber
        x['um'] = x.tempunitOfMeasureSecondary == undefined || x.tempunitOfMeasureSecondary == '' ? x.unitOfMeasureSecondary : x.tempunitOfMeasureSecondary;
        x['lotSerialNumber'] = x.lotNumber;

        if (x.returnType == 'PRT' && isReturnTypeLessThanQuantity == false && x.returnQuantity == x.orderQtyNetChange) {
          isReturnTypeLessThanQuantity = true;
        }
        return x;
      });

      if (isReturnTypeLessThanQuantity) {
        // display confirm message if existing Draft return request for the selected account and product line
        const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          panelClass: 'drafSeedReturnConfirmModal',
          data: {
            title: 'Warning',
            htmlMessage: 'Qty is same as Fill qty. Do you want to continue with that?',
            labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm'
          }
        });
        this.subscription.add(dialogRef.afterClosed().subscribe(result => {
          // If user selected ok
          if (result == true) {
            productList.map((x) => {
              if (x.returnType == 'PRT' && x.returnQuantity == x.orderQtyNetChange) {
                x['containerFillStatus'] = 'FLD';
                x['returnType'] = 'FLD';
              }
              return x;
            });

            this.saveReturnRequest(isSubmit, productList, newLineItems);
          }
          else {
            this.isPlaceOrderEnable = true;
            this.isSaveOrderDraftEnable = true;
          }
        }));
      }
      else {
        this.saveReturnRequest(isSubmit, productList, newLineItems);
      }
    }
  }

  saveReturnRequest(isSubmit: boolean, containerProductList: any, lineItems: any[]) {
    const postData = {
      ContainerReturnRequestId: this.containerReturnRequestId,
      ReturnRequestType: 'PRODUCTS',
      ReturnRequestStatus: 'DRAFT',
      CompanyCode: this.headerCompany,
      ShipToAccountId: this.shipToAccount,
      SoldToAccount: this.soldToAccount,
      IsUpdateRequest: this.containerReturnsService.getEditModeStatus(),
      DsmId: this.dsmId,
      BranchPlant: null,
      ContainerReturnProductList: containerProductList,
      Email: this.accountEmail,
      RequestedBy: this.requestedByUser,
      PickupInfo: {
        RequestDate: (this.desiredPickupDate ? (new Date(this.desiredPickupDate)).toLocaleDateString('en-US') : null),
        ContactName: (this.contactName ? this.contactName : ''),
        ContactNumber: (this.contactNumber ? this.contactNumber : ''),
        PickUpLocation: (this.deliveryAccount ? this.deliveryAccount : null),
        ShippingInstructions: (this.shippingInstructions ? this.shippingInstructions : null),
        FreightInstructions: this.freightInstructionCtrl.selectedOptions.selected.map(x => x.value.id).join(),
        PalletCount: (this.palletCount ? Number(this.palletCount) : null),
        CustPONumber: (this.customerPONumber ? this.customerPONumber : '')
      },
    };
    this.loaderService.setLoaderStatus(true);

    this.subscription.add(this.containerReturnsService.submitReturnRequest(postData).subscribe((result: any) => {
      if (result) {
        if (result.errors.length > 0) {
          this.loaderService.setLoaderStatus(false);
          result.errors.forEach(x => {
            this.toastrService.error(x);
            return false;
          });
        }
        else {
          const errorCount = result.containerReturnProductList.filter(x => x.errorMessage != null).length;
          if (errorCount > 0) {
            this.productAllDataSource.data = result.containerReturnProductList;
            this.productAllDataSource.data.forEach(x => {
              const item = lineItems.filter(y => y.itemId == x.itemId);
              if (item.length > 0) {
                x.lineStatus = item[0].lineStatus;
              }
              if (x.errorMessage != '' && x.errorMessage != null) {
                x.lineErrors = { 'itemId': x.itemId, 'errors': [{ 'error': x.errorMessage }] };
                this.errorMsgs.push(x.lineErrors);
              }
              else {
                x.lineErrors = { 'itemId': x.itemId, 'errors': [] };
              }
            });
            this.getCommonErrors(this.errorMsgs);
            this.loaderService.setLoaderStatus(false);
          } else {
            const successMsg = 'Container Return Request saved successfully.';
            this.toastrService.success(successMsg);

            if (isSubmit) {
              this.router.navigate([`/container-returns/products-review/${result.containerReturnRequestId}`]);
            } else {
              this.router.navigate(['/container-returns/dashboard-products']);
            }

            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
            this.loaderService.setLoaderStatus(false);
          }
        }
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.isPlaceOrderEnable = true;
      this.isSaveOrderDraftEnable = true;
      this.toastrService.error('Return Request not saved in the system.');
    }));
  }

  countShouldBeValid(count: AbstractControl) {
    if (count.valid) {
      this.isPalletValid = true;
    } else {
      this.isPalletValid = false;
    }
  }
  phoneShouldBeValid(phone: AbstractControl) {
    if (phone.valid) {
      this.isContactValid = true;
    } else {
      this.isContactValid = false;
    }
  }
  nameShouldBeValid(name: AbstractControl) {
    if (name.valid) {
      this.isNameValid = true;
    } else {
      this.isNameValid = false;
    }
  }

  // Set Tab to show
  showTab(tabid: string) {
    this.tabNode = tabid;
  }

  // update grid value from toolKit on update
  setAllFields(field: string, value: any) {
    switch (field) {
      case 'delete':
        this.tabNode = '';
        if (value) {
          this.isAllProductChecked = false;
          this.showTabs = false;
          this.editToolKit = false;
          const productAllList = this.productAllDataSource.filteredData.filter(x => x.isSelected === true);

          if (productAllList.length == this.productAllDataSource.data.length) {
            this.errorMsgs = [];
            this.productAllDataSource = new MatTableDataSource([]);
            this.bindDataSource([], true);
            this.originalProductItemsDataSource = [];
          } else {
            productAllList.forEach(items => {
              let index = this.errorMsgs.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber;
              });
              if (index !== -1) {
                this.errorMsgs.splice(index, 1);
              }
              index = this.productAllDataSource.data.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber;
              });
              if (index !== -1) {
                this.productAllDataSource.data.splice(index, 1);
              }

              index = this.originalProductItemsDataSource.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber;
              });
              if (index !== -1) {
                this.originalProductItemsDataSource.splice(index, 1);
              }
            });
          }
          this.applyFilterData(this.productFilters);
          this.checkBoxCount = 0;
          this.selectedCount = this.productAllDataSource.data.length;
          if (this.selectedCount == 0) {
            this.disablecheckbox = true;
          }
        }

        this.enablePlaceOrderAndSaveOrderDraft();
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
        break;
      default:
        break;
    }
  }

  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.editToolKit = true;

      this.checkBoxCount = this.productAllDataSource.filteredData.filter(x => x.isSelected == true).length;
      const checked = this.productAllDataSource.filteredData.filter(x => x.isSelected == false);

      if (checked && checked.length == 0) {
        this.isAllProductChecked = true;
      }
      else {
        this.isAllProductChecked = false;
      }
    }
    else {
      this.checkBoxCount = this.checkBoxCount - 1;
      this.isAllProductChecked = false;
      const selected = this.productAllDataSource.filteredData.filter(x => x.isSelected == true);
      {
        if (selected && selected.length == 0) {
          this.showTabs = false;
        }
        else {
          this.showTabs = true;
        }
      }
    }
    this.editToolKit = false;
    const selectedItem = this.productAllDataSource.filteredData.filter(x => x.isSelected == true);
    this.isValidLineStatus = false;
    if (selectedItem.length > 0) {
      this.isValidLineStatus = selectedItem.filter(item => item.lineStatus == '' || item.lineStatus == null || item.lineStatus == 'DRAFT' || item.containerReturnRequestItemId == 0).length > 0 ? true : false;
      this.editToolKit = true;
      if (this.isValidLineStatus && this.containerReturnsService.getEditModeStatus()) {
        this.showTabs = true;
        this.isSearchClicked = false;
      } else if (!this.isValidLineStatus && this.containerReturnsService.getEditModeStatus()) {
        this.editToolKit = false;
      }
    }
  }

  // for validation of data on submit
  validateOrder(isSubmit: boolean) {
    let isValidated = true;

    if (this.productAllDataSource.data && this.productAllDataSource.data.length > 0) {
      isValidated = true;
      this.productAllDataSource.data.forEach(x => {
        if (x.lineStatus !== 'REJECTED') {
          x = this.validateQty(x);
          x = this.validateReturnType(x);
          if (x.lineErrors.errors.length > 0) {
            isValidated = false;
          }
        } else {
          x.lineErrors.errors = [];
        }
      });
    }

    if (this.isPickupDateValid) {
      if (!this.desiredPickupDate || this.desiredPickupDate == '') {
        // this.SetDesiredPickupDate();
      }
      else if (this.desiredPickupDate < new Date(new Date().setHours(0, 0, 0, 0))) {
        isValidated = false;
        this.toastrService.error('Desired pickup date should be today or greater.');
      }
    } else {
      isValidated = false;
      if (!isSubmit) {
        this.toastrService.error('Requested Desired pickup date is invalid.');
      }
    }

    if (isSubmit) {
      if (!this.desiredPickupDate) {
        isValidated = false;
        this.toastrService.error('Please enter desired pickup date.');
      }
      // else if (this.desiredPickupDate < new Date(new Date().setHours(0, 0, 0, 0))) {
      //  isValidated = false;
      //  this.toastrService.error('Desired pickup date should be today or greater.');
      // }
      else if (!this.contactName) {
        isValidated = false;
        this.toastrService.error('Please enter a contact name.');
      } else if (!this.contactNumber) {
        isValidated = false;
        this.toastrService.error('Please enter a contact number.');
      }
    }
    return isValidated;
  }

  UpdateDeliverToSelection(isDeliverToOptionChecked) {
    if (!isDeliverToOptionChecked) {
      this.deliveryAccount = null;
      // this.getDefaultDeliveryDate(event);
    }
  }

  getDefaultDeliveryDate(event) {
    this.desiredPickupDate = new Date(this.desiredShipToPickupDate);
  }

  // validate individual line item
  checkAnyValidLineItem() {
    const errorCount = this.productAllDataSource.data.filter(x => x.lineErrors.errors.length > 0).length;
    return (errorCount > 0 ? false : true);
  }

  // for common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.itemId == this.nextErrorId && x.lotNumber == this.nextLotNumber) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].itemId;
      this.nextLotNumber = this.errorMsgs[this.index].lotNumber;
      this.currentErrorRow = this.index + 1;
      $('#returnRequestView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
        $('#returnRequestView').animate({ scrollTop: nextOffset }, 1000);
      }
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].itemId;
      this.nextLotNumber = this.errorMsgs[this.index].lotNumber;
      this.currentErrorRow = 1;
      $('#returnRequestView').scrollTop = 0;
      $('#returnRequestView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.originalProductItemsDataSource.length > 0 && this.productAllDataSource.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.originalProductItemsDataSource.filter(x => x.itemId === element.itemId && x.lotNumber === element.lotNumber)[0];
        oldLineValue.lineErrors = { 'itemId': oldLineValue.itemId, 'lotNumber': oldLineValue.lotNumber, 'errors': [] };;

        // get current object index
        const currentLineIndex = this.productAllDataSource.data.findIndex(x => x.itemId === element.itemId && x.lotNumber === element.lotNumber);

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          this.productAllDataSource.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
          this.productAllDataSource.data = this.productAllDataSource.data;
          const index = this.errorMsgs.findIndex(function (element) {
            return element.itemId === oldLineValue.itemId && element.lotNumber === oldLineValue.lotNumber;
          });
          if (index !== -1) {
            this.errorMsgs.splice(index, 1);
          }
          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.itemId, oldLineValue.lotNumber);
          this.getCommonErrors(this.errorMsgs);
        }
      }
      else {
        // replace whole object
        this.productAllDataSource.data = JSON.parse(JSON.stringify(this.originalProductItemsDataSource));
        this.productAllDataSource.data.forEach(x => {
          x.eligibleUnit = x.isManualLine ? 0 : ((x.invoiceUnits && x.totalReturnUnits) ? (x.invoiceUnits - x.totalReturnUnits) : x.eligibleUnit);
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
        });
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
    if (this.errorMsgs.length > 0) {
      this.showTabs = false;
      this.isSearchClicked = true;
      this.editToolKit = false;
      this.isPlaceOrderEnable = true;
      this.isSaveOrderDraftEnable = true;
    }
    this.enablePlaceOrderAndSaveOrderDraft();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
    this.checkBoxCount = 0;
    this.showTabs = false;
    this.isSearchClicked = true;
    this.editToolKit = false;
    this.isAllProductChecked = false;
  }

  // Hide and show error line error
  showHideLineError(errorId: number, lotNumber: string) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString() + '_' + lotNumber);
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Dealer unit change and validation
  unitChange(action: string, productItem: any) {
    productItem.lineErrors.errors = [];
    const index = this.errorMsgs.findIndex(function (element) {
      return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
    });
    if (index !== -1) {
      this.errorMsgs.splice(index, 1);
    }
    if (action == 'decrease') {
      let decValue;
      if (productItem.uom !== productItem.unitOfMeasureSecondary && (productItem.conversionFactor > 0)) {
        decValue = +productItem.returnQuantity - +productItem.conversionFactor;
        if (decValue > 0) {
          const valueBeforeDec = productItem.returnQuantity;
          productItem.returnQuantity = Math.floor(productItem.returnQuantity / +productItem.conversionFactor) * +productItem.conversionFactor;
          if (valueBeforeDec == productItem.returnQuantity) {
            productItem.returnQuantity = (+productItem.returnQuantity > +productItem.conversionFactor ? +productItem.returnQuantity - +productItem.conversionFactor : 0);
          }
        }
      } else {
        decValue = + parseInt(productItem.returnQuantity) - 1;
      }
      if (decValue > 0) {
        productItem.returnQuantity = decValue;
      }
      else {
        productItem.returnQuantity = 0;
        if (decValue < 0) {
          this.toastrService.error('Requested units cannot be negative.');
        }
      }
      productItem = this.validateQty(productItem);
    }
    else {
      if (productItem.uom !== productItem.unitOfMeasureSecondary && (productItem.conversionFactor > 0)) {
        const valueBeforeInc = productItem.returnQuantity;
        productItem.returnQuantity = Math.ceil(productItem.returnQuantity / +productItem.conversionFactor) * +productItem.conversionFactor;
        if (valueBeforeInc == productItem.returnQuantity) {
          productItem.returnQuantity = (+productItem.returnQuantity + +productItem.conversionFactor);
        }
      } else {
        productItem.returnQuantity = +productItem.returnQuantity + 1;
      }
      productItem = this.validateQty(productItem);
    }

    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.originalProductItemsDataSource)).filter(x => x.itemId == productItem.itemId && x.lotNumber == productItem.lotNumber)[0];
    this.setCount();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldReturnQty: oldProductLineValue.returnQuantity, newReturnQty: productItem.returnQuantity });
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  // validate qty feild in product details.
  validateQty(productItem) {
    if (productItem.returnQuantity === '' || productItem.returnQuantity === 0 || Number(productItem.returnQuantity) === 0) {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnEmptyQuantity');
      productItem.lineErrors.errors.push({ id: 'returnEmptyQuantity', error: 'Please enter a return units' });
    } else if (Number(productItem.returnQuantity) < 0) {
      productItem.lineErrors.errors.push({ id: 'returnEmptyQuantity', error: 'Please enter a positive number return units' });
    }
    else if (Number(productItem.returnQuantity) > productItem.orderQtyNetChange) {
      productItem.lineErrors.errors.push({ id: 'returnEmptyQuantity', error: 'Return units should not be greater than Order Qty. Net Change units.' });
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnEmptyQuantity');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    // Return Quantity
    if (productItem.uom != productItem.unitOfMeasureSecondary && (productItem.conversionFactor > 0) && productItem.returnQuantity < productItem.eligibleUnit && (productItem.returnQuantity % productItem.conversionFactor) !== 0) {
      productItem.lineErrors.errors.push({ id: 'returnQuantity', error: 'Please re-enter your Return Units in multiples of ' + (productItem.conversionFactor) });
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnQuantity');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }
    if (productItem.lineErrors.errors.length > 0) {
      this.errorMsgs.push(productItem.lineErrors);
      this.getCommonErrors(this.errorMsgs);
    }
    return productItem;
  }

  // validate return type in product details.
  validateReturnType(productItem) {
    if (productItem.returnType === '' || productItem.returnType === undefined || productItem.returnType === null) {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnType');
      productItem.lineErrors.errors.push({ id: 'returnType', error: 'Please enter a return type' });
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'returnType');
      const index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    return productItem;
  }

  // Qty change on text change
  quantityTextChange(productItem) {
    productItem.lineErrors.errors = [];
    const index = this.errorMsgs.findIndex(function (element) {
      return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
    });
    if (index !== -1) {
      this.errorMsgs.splice(index, 1);
    }

    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.originalProductItemsDataSource)).filter(x => x.itemId == productItem.itemId && x.lotNumber == productItem.lotNumber)[0];
    this.setCount();

    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldReturnQty: oldProductLineValue.returnQuantity, newReturnQty: productItem.returnQuantity });
    productItem = this.validateQty(productItem);
    this.isAddProductEnable = true;
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  // for notes
  hasNotesChanged(textInput: string) {
    if (textInput && textInput.length > 0) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { seedReturnValue: true });
    }
    if (textInput && textInput.length >= 250) {
      this.toastrService.error('The maximum number of characters has been been reached.');
    }
  }

  setCount() {
    this.filteredDataCount = 0;
    this.qtyCount = 0;
    this.totalPrice = 0;
    this.filteredDataCount = this.productAllDataSource.data.length;
  }

  // Validate the email address entered
  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  // get list of accounts
  getAccountList() {
    this.subscription.add(this.containerReturnsService.getAccountList().subscribe((result: any[]) => {
      this.shipToAccountItems = result;
      this.shipToDataLoading = false;
      if (this.shipToAccount) {
        const accountItem = this.shipToAccountItems.filter(x => x.accountNumber === this.shipToAccount);
        if (accountItem) {
          this.selectedAccountName = accountItem[0].accountName;
          this.shipToAccountName = accountItem[0].accountName;
          this.soldToFacility = [accountItem[0].soldToAccount];
          this.soldToAccount = accountItem[0].soldToAccount.accountNumber;

          this.fetchDeliverToFacilityList(accountItem[0].accountNumber, accountItem[0].parentNumber);
        }
      }
    }, ((error) => {
      this.loaderService.setLoaderStatus(false);
      this.shipToDataLoading = false;
    })));
  }

  // get list of return Type
  getReturnTypeList() {
    this.subscription.add(this.containerReturnsService.getReturnType().subscribe((result: any[]) => {
      this.returnTypeArray = result;
      LolLoggerService.info(this.returnTypeArray);
    }, ((error) => {
      this.loaderService.setLoaderStatus(false);
    })));
  }

  // get freight list
  getFreightList() {
    if (this.localStorageService.get(MasterConstants.FREIGHT_INSTRUCTION_MASTER_LIST)) {
      this.freightInstruction = JSON.parse(this.localStorageService.get(MasterConstants.FREIGHT_INSTRUCTION_MASTER_LIST));
    }
  }

  // On page destroy
  ngOnDestroy() {
    this.containerReturnsService.setContainerReturnRequestId(0);

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // get list of deliver to accounts based on accountnumber adn parent number
  public fetchDeliverToFacilityList(accountNumber: number, parentNumber: number) {
    this.subscription.add(this.containerReturnsService.getDeliverToFacilityList(accountNumber, parentNumber)
      .subscribe((result: any[]) => {
        this.deliveryAccountList = result;
      }, error => this.loaderService.setLoaderStatus(false))
    );
  }

  public isDisableSubmitRequestBtn(): boolean {
    return !this.isSaveOrderDraftEnable;
  }

  public isDisableSaveDraftBtn(): boolean {
    return !this.isSaveOrderDraftEnable;
  }

  desiredPickupDateValid(pickupDate: AbstractControl) {
    if (pickupDate.valid && pickupDate['model'] >= new Date(new Date().setHours(0, 0, 0, 0))) {
      this.isPickupDateValid = true;
    } else {
      this.isPickupDateValid = false;
    }
  }

  ValidateSelectedDesiredPickupDate(event) {
    if (event.value && event.value >= new Date(new Date().setHours(0, 0, 0, 0))) {
      this.isPickupDateValid = true;
    } else {
      this.isPickupDateValid = false;
    }
  }

  onOpen() {
    if (this.isAcctSDM) {
      setTimeout(() => { this.appendFooter(); }, 0);
    }
  }

  appendFooter() {
    const matCalendar = document.getElementsByClassName('mat-datepicker-content')[0] as HTMLElement;
    matCalendar.appendChild(this.datepickerFooter.nativeElement);
  }
}
